/* eslint-disable implicit-arrow-linebreak */
export const URLS = {
  API_ENDPOINTS: {
    GCP_DEV: 'https://global-channel-provider-service-dev.care-staging.vpsvc.com',
    GCP_PROD: 'https://global-channel-provider-service.care.vpsvc.com',
    PROFILE: (accountId: string): string => `https://profile.cimpress.io/v1/${accountId}/profile/me`,
    TRANSLATIONS: (locale: string): string =>
      `https://chat-anywhere.care.vpsvc.com/ubik-config/translations/${locale}-translations.json`,
  },
  NEW_RELIC: 'https://chat-anywhere.care.vpsvc.com/JS-build/newRelicInit.js',
  NOTIFICATION_SOUND: 'https://dqq742lm0w7m1.cloudfront.net/JS-build/incoming.mp3',
};
